import React, { useState } from 'react';
import { MagnifierContainer, MagnifierPreview, MagnifierZoom } from 'react-image-magnifiers';

function SampleImg({ src, zoomClass }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleLoad = () => setLoaded(true);
  const handleError = () => {
    setLoaded(true);
    setError(true);
  };

  return (
    <div className="sample-img-wrapper">
      {!loaded && (
        <div className="sample-img-loader">
          <div className="spinner-border text-secondary" role="status" />
        </div>
      )}
      {error ? (
        <div className="sample-img-error text-secondary text-center p-2">Image not available</div>
      ) : (
        <div style={{ display: loaded ? 'block' : 'none' }}>
          {zoomClass ? (
            <MagnifierContainer>
              <div className="example-class">
                <MagnifierPreview imageSrc={src} />
              </div>
              <MagnifierZoom className={zoomClass} imageSrc={src} />
            </MagnifierContainer>
          ) : (
            <img src={src} alt="Sample" className="img-fluid" />
          )}
        </div>
      )}
      {/* hidden img used only to detect load/error completion */}
      {!loaded && <img src={src} alt="" style={{ display: 'none' }} onLoad={handleLoad} onError={handleError} />}
    </div>
  );
}

export default SampleImg;
